module.exports = __webpack_public_path__ + "img/caja.05cce9ab.png";